import FilterRegister from "../../../../components/filter/register-basic";
import reqEmpresaBanner from "../../../../services/reqMultiTenant/reqEmpresaBanner";
import LibBoolean from "../../../../util/libBool";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import FormPayment from "../form";

const MainRegisterBanner = () => {
	const options = {
		id: "id_banner", //usado para saber qual field usar para atualizar
		ident: "registerFormBanner", //usado para definir os event listners
		identFilter: "filterFormBanner", //usado para definir os event listners
		title: "Banners",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "url_banner", label: "Imagem", format: "banner", align: "left", width: 130 },
			{ key: "descricao", label: "Descrição", align: "left", width: 250 },
			{ key: "ordem", label: "Ordem", align: "center", width: 150 },
			{ key: "ativo", label: "Ativo", align: "center" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Descrição.", value: "descricao" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const newActive = LibBoolean.strToBoolean(active);

		const response = await reqEmpresaBanner.listPaginate(param, paramValue, newActive, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqEmpresaBanner.listId(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqEmpresaBanner.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormPayment} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterBanner;
